import React from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'

import { reverse } from 'routes'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'
import { getMakerName, getBrandName } from 'utils/vehicle'

import { CLIENT_DETAIL_URL, VEHICLE_DETAIL_URL } from 'constants'

import {
  vehicleChanged,
  userChanged,
  policyChange,
  documentsChanged
} from 'scenes/VehicleDetail/actions'

import Breadcrumb from 'components/Breadcrumb'

import './styles.scss'

import Claim from './components/Claim'
import Data from './components/Data'
import ClaimData from './components/ClaimData'
import Drivers from './components/Drivers'
import Policy from './components/Policy'


export class VehicleDetail extends BaseComponent {

  static defaultProps = {
    policy: {},
    vehicle: {},
    user: {}
  }

  SECTIONS = {
    siniestro: Claim,
    datossiniestro: ClaimData,
    detalle: Data,
    conductores: Drivers,
    poliza: Policy,
    claimhistoric: Claim,
    claimdatahistoric: ClaimData
  }

  _fetch() {
    this._fetchVehicleData()
    this._fetchClientData()
  }
  
  componentDidMount() {
    this._fetch()
  }

  componentWillReceiveProps(nextProps) {
    this.props.match.params.id !== nextProps.match.params.id && this._fetch()
  }

  _fetchClientData() {
    const params = this.props.match.params
    request(CLIENT_DETAIL_URL(params.id))
    .then(({user}) => {
      this.props.userChanged(user)
    })
    .catch(console.log)
  }

  _fetchVehicleData() {
    const params = this.props.match.params

    request(VEHICLE_DETAIL_URL(params.id, params.vehicleId))
    .then(({vehicle, policy, documents}) => {
      this.props.policyChange(policy)
      this.props.vehicleChanged(vehicle)
      this.props.documentsChanged(documents)
    })
    .catch(console.error)
  }

  _renderSectionTabs(user, vehicle, claimId){
    return (claimId) ? (
      <div className="VehicleDetail__nav">
          <div className="VehicleDetail__nav">
            <ul>
              <li>
                <NavLink  to={reverse('clients:detailhistory:claimhistoric', {id:  user.uuid, vehicleId: vehicle.id, claimId: claimId})}
                          exact activeClassName="active">Estado del siniestro</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detailhistory:claimdatahistoric', {id:  user.uuid, vehicleId: vehicle.id, claimId: claimId})}
                          exact activeClassName="active">Datos del siniestro</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detailhistory:datahistoric', {id: user.uuid, vehicleId: vehicle.id, claimId: claimId})}
                          exact activeClassName="active">Datos del coche</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detailhistory:policyhistoric', {id: user.uuid, vehicleId: vehicle.id, claimId: claimId})}
                          exact activeClassName="active">Póliza</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detailhistory:drivershistoric', {id: user.uuid, vehicleId: vehicle.id, claimId: claimId})}
                          exact activeClassName="active">Conductores</NavLink>
              </li>
            </ul>
          </div>
      </div>
    ) : (
          <div className="VehicleDetail__nav">
            <ul>
              <li>
                <NavLink  to={reverse('clients:detail:claim', {id: user.uuid, vehicleId: vehicle.id})}
                          exact activeClassName="active">Estado del siniestro</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detail:claimdata', {id: user.uuid, vehicleId: vehicle.id})}
                          exact activeClassName="active">Datos del siniestro</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detail:data', {id: user.uuid, vehicleId: vehicle.id})}
                          exact activeClassName="active">Datos del coche</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detail:policy', {id: user.uuid, vehicleId: vehicle.id})}
                          exact activeClassName="active">Póliza</NavLink>
              </li>
              <li>
                <NavLink  to={reverse('clients:detail:drivers', {id: user.uuid, vehicleId: vehicle.id})}
                          exact activeClassName="active">Conductores</NavLink>
              </li>
            </ul>
          </div>
    )
  }

  render() {
    var claimId = this.props.match.params.claimId
    const user = this.props.user,
      vehicle = this.props.vehicle,
      policy = this.props.policy

    const clientName = !!user.first_name ? `${user.first_name} ${user.last_name}` : ''
    const plates = !!vehicle.plates ? `(${vehicle.plates})` : ''

    const breadcrumbKeys = {
      displayValues: { client_name: clientName, plate: vehicle.plates },
      pathValues: { id: this.props.match.params.id}
    }

    var SectionComponent = this.SECTIONS[this.props.match.params.section] || null

    const Section = SectionComponent ? (
      <SectionComponent
        match={this.props.match}
        policy={this.props.policy}
        breadcrumb={this.props.breadcrumb}
      />
    ) : null

    return !!this.props.vehicle.id ? (
      <div id="VehicleDetail">
        <Breadcrumb levels={this.props.breadcrumb} keys={breadcrumbKeys} />
        <div className="VehicleDetail__header">
          <div className="VehicleDetail__data">
            <div className="VehicleDetail__name">
              <p>{getMakerName(vehicle)} - {getBrandName(vehicle)} <span>{plates}</span></p>
            </div>
            <div className="VehicleDetail__meta">
              <p>Poliza: <span>{policy.number}</span></p>
              <p>Aseguradora: <span>{policy.company}</span></p>
              {!!vehicle.alias && <p>Alias: <span>{vehicle.alias}</span></p>}
            </div>
          </div>
          { this._renderSectionTabs(user, vehicle, claimId) }
        </div>
        <div>
          { Section }
        </div>
      </div>
    ) : null
  }
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.vehicleDetail.get('vehicle').toObject(),
    policy: state.vehicleDetail.get('policy').toObject(),
    user: state.vehicleDetail.get('user').toObject()
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    vehicleChanged: (vehicle) => dispatch(vehicleChanged(vehicle)),
    userChanged: (user) => dispatch(userChanged(user)),
    policyChange: (policy) => dispatch(policyChange(policy)),
    documentsChanged: (documents) => dispatch(documentsChanged(documents))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDetail)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/index.js